<mat-card style="box-shadow: none; padding: 0px !important;" [class.mat-elevation-z1]="'true'">
    <mat-card-header>
        <span mat-card-avatar>
            <mat-icon>schedule</mat-icon>
        </span>
        <mat-card-title>Record status: {{ data.actionLabel }}</mat-card-title>
    </mat-card-header>
    <mat-dialog-content>
        <p class="dialog-message">Select the date and time for this status update.</p>
        <mat-form-field appearance="outline" class="datetime-field">
            <mat-label>Date &amp; time</mat-label>
            <input matInput type="datetime-local" [(ngModel)]="selectedDatetime" />
        </mat-form-field>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <mat-dialog-actions align="end">
        <button type="button" mat-button (click)="cancel()">Cancel</button>
        <button mat-raised-button color="primary" (click)="confirm()">Confirm</button>
    </mat-dialog-actions>
</mat-card>
